<template>
  <div id="applicationStatistical">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'applicationStatistical'
}
</script>




// WEBPACK FOOTER //
// src/views/exhibition/prediction/applicationStatistical/ApplicationStatistical.vue